var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUnpinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.648 14.598a.8.8 0 0 1-.07.106l-.057.064-1.2 1.2a.8.8 0 0 1-1.056.066l-.076-.067-2.234-2.233-3.034 3.033a.8.8 0 0 1-1.198-1.056l.067-.075 3.033-3.034-2.233-2.234a.8.8 0 0 1-.067-1.056l.067-.076 1.199-1.199 6.86 6.561ZM12.338 3a.802.802 0 0 1 .507.17l.075.067 4.4 4.4a.8.8 0 0 1-.94 1.271l-2.537 2.537-.642 1.71-5.99-5.729 1.9-.713 2.536-2.535A.8.8 0 0 1 12.337 3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.811 3.01a.713.713 0 0 1 1.008-.024l13.846 13.198a.713.713 0 0 1-.985 1.03L2.834 4.018a.713.713 0 0 1-.023-1.008"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUnpinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/unpin-icon.bd8082c9d65d2035f8293db4d9dd8fb5.svg";